import { Helmet } from "react-helmet-async";

export default function ThriveFavicon(): React.ReactElement {
  return (
    <Helmet>
      <link rel="icon" href="/favicon-thrive.ico" />
    </Helmet>
  );
}
